let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yryI"), load("7Creg"), load("aAlxB")]).then(() => parcelRequire('3nhuO'));